export default __webpack_public_path__ + "media/images/shapes/burger-01e853470b5fdc711aeb7966d3f1184f.svg";